import { render, staticRenderFns } from "./iras.vue?vue&type=template&id=2f2f9912&scoped=true&"
import script from "./iras.vue?vue&type=script&lang=js&"
export * from "./iras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2f9912",
  null
  
)

export default component.exports